import { post } from "@/util/http";

console.log("==========================");
console.log("当前版本:", VERSION, "当前环境:", ENV, "当前站点:", SITE);
console.log("==========================");

import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import ElementUI, { Message } from "element-ui";
import VueLazyload from "vue-lazyload";
import VueI18n from "vue-i18n";
import VueQriously from "vue-qriously";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/reset.css";
import "@/assets/font.css";
import "@/assets/iconfont/iconfont.css";
import "swiper/swiper-bundle.css";
import { store } from "./store/index.js";
import SVGA from "svgaplayerweb";
import VueClipboard from "vue-clipboard2";
import IdleVue from "idle-vue";
import * as echarts from "echarts";
import MetaInfo from "vue-meta-info";
import * as utils from "@/util/time";
import { fixedNumber } from "@/util/picNumber";

// 根据环境变量设置ico图标
const icos = {
  onv2: "/favicon.ico",
  "8on": "/favicon_8on.ico",
  sport247: "/favicon_sport247.ico",
};
const iconUrl = icos[SITE] || "/images/favicon.ico";
if (typeof window !== "undefined") {
  document.querySelector("link[rel='icon']")?.setAttribute("href", iconUrl);
}

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 2000,
});
Vue.use(VueClipboard);
Vue.use(VueQriously);
Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(VueLazyload);
Vue.use(MetaInfo);

Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$SVGA = SVGA;
Vue.prototype.$util = utils;
Vue.prototype.$num = (value) => {
  return value.replace(/\D/g, "");
};

Vue.prototype.$numAndText = (value) => {
  return value.replace(/[\u0391-\uFFE5]/g, "");
};

Vue.prototype.$bigNumber = (num) => {
  if (num >= 10000) {
    num = fixedNumber(num / 10000, 1) + "W";
  }
  return num;
};

let locale = "en-US";
if (typeof window !== "undefined") {
  const historyLang = localStorage.getItem("lang");
  if (historyLang) {
    locale = historyLang;
  } else {
    const currentLang = window.navigator.language;
    console.log("当前系统语言:", currentLang);
    if (currentLang.includes("en")) {
      locale = "en-US";
    } else if (currentLang.includes("zh")) {
      locale = "zh-CN";
    } else if (currentLang.includes("vi")) {
      locale = "vi-VN";
    } else {
      locale = "en-US";
    }
  }
}

export const i18n = new VueI18n({
  locale,
  fallbackLocale: "en-US",
  messages: {
    "en-US": require("@/locales/en.json"),
    "zh-CN": require("@/locales/zh.json"),
    "vi-VN": require("@/locales/vi.json"),
  },
});

// document.title = "猎鹰直播_猎鹰直播视频_猎鹰体育赛事直播";

Vue.prototype.$echarts = echarts;

const app = new Vue({
  i18n,
  store,
  router,
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  render: (h) => h(App),
});
post({ url: "/api/ads/getHomeBannerBg" }).then((result) => {
  console.log("decodeResponse", result);
  if (result.status === 200) {
    const res = result.data;

    if (res.status === 0) {
      window.key2 = res.data.image_url;
    }
  }
});
app.$mount("#app");
